import React from "react";
import styled from "styled-components";
import * as ReactScroll from "react-scroll";
import { withPage } from "../Page";
import IntroItem from "../Components/GeneralItem";
import * as L from "../Utils/Lang";
import { StaticFluidImage } from "../Components/StaticImage";

class AboutUsPage extends React.Component {
  render() {
    return (
      <Wrapper banner={"images/about-me-banner.png"}>
        <div className="banner">
          <div className="blur-banner">
            <StaticFluidImage path="about-me-banner.png" />
          </div>
          <SloganWrapper>
            <Slogan large css={"margin-bottom: 30px;"}>
              {L.s("aboutUs")}
            </Slogan>
            <Slogan>{L.s("aboutUsSubtitle")}</Slogan>
          </SloganWrapper>
        </div>

        <ReactScroll.Link to="our-services" smooth={true} offset={-140}>
          {/* <ScrollIcon /> */}
        </ReactScroll.Link>

        <IntroWrapper>
          <IntroItem
            itemName="about-us-1"
            img="images/9.png"
            title={L.s("ourTech")}
            description={L.s("ourTechContent")}
          />
          <IntroItem
            itemName="about-us-2"
            img="images/10.png"
            title={L.s("contactUs")}
            description={L.s("contactUsContent")}
            reverse
          />
          <IntroItem
            itemName="about-us-3"
            img="images/11.png"
            title={L.s("whyMDC")}
            description={L.s("whyMDCContent")}
          />
        </IntroWrapper>
      </Wrapper>
    );
  }
}

let Wrapper = styled.div`
  background-color: black;
  & .blur-banner {
    @media screen and (max-width:700px) {
      display: none;
    } 
  }
  & > .banner {
    background-color: lightgray;
    position: relative;
    @media screen and (max-width:700px) {
      height: 90vh;
      background-image: url('${props => props.banner}');
      background-size: cover;
      background-repeat: none;
      background-position: center;
    } 
  }
`;
let Banner = styled.div`
    background-color: #ccc;
    background-image: url('${props => props.img}');
    background-size: cover;
    background-repeat: none;
    background-position: center;
    width: 100vw;
    height: 100vh;
    /* top:-90px; */
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    @media screen and (max-width:700px) {
    }
`;

let SloganWrapper = styled.div`
  position: absolute;
  padding: 10px;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, 0.5);
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  @media screen and (max-width: 700px) {
    /* position: static;
    transform: none;
    padding: 20px;
    padding-top: 100px; */
    transform: translate(-50%, -40%);
  }
`;

let Slogan = styled.div`
  font-size: ${props => (props.large ? 40 : 18)}px;
  font-weight: ${props => (props.large ? 500 : 400)};
  color: ${props => (props.large ? "#418DB9" : "#fff")};
  line-height: ${props => (props.large ? 55 : 33)}px;
  letter-spacing: 1px;
  text-align: left;

  @media screen and (max-width: 700px) {
    font-size: ${props => (props.large ? 26 : 16)}px;
    line-height: ${props => (props.large ? 30 : 20)}px;
  }
  ${props => props.css}
`;

let IntroWrapper = styled.div``;

export default withPage(AboutUsPage);
